import { cn } from '@repo/shared-client/lib/utils'
import { forwardRef } from 'react'
import LogoSymbol from '../logo-symbol/logo-symbol'

interface SFSpinnerProps extends React.ComponentProps<'div'> {
  name?: string
  size?: 'md' | 'lg' | 'sm'
}

const sizeClassBySize: Record<NonNullable<SFSpinnerProps['size']>, string> = {
  lg: 'min-w-[200px] w-[200px]',
  md: 'min-w-[100px] w-[100px]',
  sm: 'min-w-[50px] w-[50px]',
}

const SFSpinner = forwardRef<HTMLDivElement, SFSpinnerProps>((props, forwardedRef) => {
  const { size = 'sm', name: _name, className, ...rest } = props

  return (
    <div className={cn('flex flex-row items-center', className)} ref={forwardedRef} {...rest}>
      <LogoSymbol imageClassName={cn('animate-[sf-rotateplane_1.2s_ease-in-out_infinite]', sizeClassBySize[size])} />
    </div>
  )
})

SFSpinner.displayName = 'SFSpinner'

export default SFSpinner
